import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAnswer } from '../../actions/questionActions';
import { Form } from 'react-bootstrap';

const YesNo = ({ title, idPregunta, observacion }) => {
    const dispatch = useDispatch();
    const answers = useSelector(state => state.question.answers);
    const reduxAnswer = answers[idPregunta]?.answer || '';
    const reduxObservacion = answers[idPregunta]?.observacion || '';
    const [answerValue, setAnswerValue] = useState(reduxAnswer);
    const [observacionValue, setObservacionValue] = useState(reduxObservacion);

    useEffect(() => {
        setAnswerValue(reduxAnswer);
        setObservacionValue(reduxObservacion);
    }, [idPregunta]);

    const handleChange = (event) => {
        setAnswerValue(event.target.value);
        dispatch(setAnswer(idPregunta, event.target.value, observacionValue));
    };

    const handleObservacion = (textValue) => {
        setObservacionValue(textValue);
        dispatch(setAnswer(idPregunta, answerValue, textValue));
    };
    
    return (
        <div className="form-check">
            <label className='question-subtitle'>{title}</label>
            <div style={{marginLeft:'5%',marginTop:'2%',marginBottom:'6%'}}>
            <div>
                <input
                    type="radio"
                    id={`si${idPregunta}`}
                    className='form-check-input'
                    name={`tituloSi${idPregunta}`}
                    value="1"
                    checked={answerValue == "1"}
                    onChange={handleChange}
                />
                <label style={{marginBottom:'1%'}} className="form-check-label" htmlFor={`si${idPregunta}`}>Sí</label>
            </div>
            <div>
                <input
                    type="radio"
                    id={`no${idPregunta}`}
                    className='form-check-input'
                    name={`tituloNo${idPregunta}`}
                    value="0"
                    checked={answerValue == "0"}
                    onChange={handleChange}
                />
                <label style={{marginBottom:'1%'}} className="form-check-label" htmlFor={`no${idPregunta}`}>No</label>
            </div>
            </div>
            {observacion &&                
                <Form.Group className="tipo-de-credencial-parent mb-3">
                    <Form.Label className='nombre'>Observaciones:</Form.Label>
                    <Form.Control as="textarea" rows={3} placeholder="Ingresá tu respuesta" required value={observacionValue} onChange={(e) => handleObservacion(e.target.value)} />
                </Form.Group>
            }
        </div>
    );
};

export default YesNo;